import React, { useEffect, useState } from "react";
import { IoArrowBack, IoArrowForward } from "react-icons/io5";

type PaginationProps = {
  page: number;
  itemsPerPage: number;
  totalItems: number;
  onPageChange: (page: number) => void;
};

const Pagination = ({ page, itemsPerPage, totalItems, onPageChange }: PaginationProps) => {
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const [currentPage, setCurrentPage] = useState(page);

  useEffect(() => {
    setCurrentPage(page);
  }, [page]);

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    onPageChange(page);
  };

  const renderPageNumbers = () => {
    const pageNumbers = [];
    const maxVisiblePages = 5; // Change this to the desired number of visible pages

    if (totalPages <= maxVisiblePages) {
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
      }
    } else {
      const middlePage = Math.ceil(maxVisiblePages / 2);
      const startPage = Math.max(1, currentPage - middlePage + 1);
      const endPage = Math.min(startPage + maxVisiblePages - 1, totalPages);
      if (startPage === 2) {
        pageNumbers.push(1);
      }
      if (startPage > 2) {
        pageNumbers.push(1, "...");
      }

      for (let i = startPage; i <= endPage; i++) {
        pageNumbers.push(i);
      }

      if (endPage < totalPages) {
        pageNumbers.push("...");
      }
    }

    return pageNumbers.map((page, index) => (
      <button
        key={index}
        onClick={() => (typeof page === "number" ? handlePageChange(page) : null)}
        // className="h-10 w-10 rounded-md border-2 border-[#231F20]/40 text-black"
        className={`${
          currentPage === page
            ? `border-primaryPurple-100 bg-primaryPurple-100 text-white`
            : `border-[#231F20]/40`
        } h-10 w-10 rounded-md border-2 text-black`}
      >
        {page}
      </button>
    ));
  };

  return totalItems ? (
    <div className="flex space-x-3">
      <button
        className={`${
          currentPage === 1
            ? "border-2 border-[#DFE3E8] text-[#DFE3E8]"
            : "cursor-pointer border-2 border-black text-[#714ECE]"
        } rounded-md p-2 font-bold`}
        disabled={currentPage === 1}
        onClick={() => handlePageChange(currentPage - 1)}
      >
        <IoArrowBack className="text-xl" />
      </button>

      <ul className=" flex gap-2">{renderPageNumbers()}</ul>

      <button
        className={`${
          currentPage === totalPages
            ? "border-2 border-[#DFE3E8] text-[#DFE3E8]"
            : "cursor-pointer border-2 border-black text-[#714ECE]"
        } rounded-md p-2 font-bold`}
        onClick={() => handlePageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
      >
        <IoArrowForward className="text-xl" />
      </button>
    </div>
  ) : (
    <></>
  );
};

export default Pagination;
